import FacebookIcon from '@mui/icons-material/Facebook';

export const DEFAULT_SITE = 'facebook';

// How each site looks; a site missing here falls back to its backend label
const SITE_META = {
  facebook: {
    name: 'Facebook',
    color: '#1877f2',
    icon: FacebookIcon,
    accountLabel: 'Facebook user ID',
    description: 'Sync ad accounts, campaigns, ad sets, ads and daily insights from Meta Ads.',
    loginHint: 'Adds the Facebook account signed in on this browser. To add a different one, switch accounts on '
      + 'facebook.com first.',
  },
};

export function siteMeta(site) {
  return SITE_META[site.site] ?? { name: capitalize(site.label), color: '#6b7280' };
}

function capitalize(value) {
  return value ? value[0].toUpperCase() + value.slice(1) : value;
}
